import { getContext } from '@fiverr-private/fiverr_context';
import { EXPERIMENTS, ALLOCATIONS } from '../constants/experiments';

interface HourlyPriceDisplayResult {
    showHourlyPrice: boolean;
    shouldRouteToSeller: boolean;
}

export const useHourlyPriceDisplay = (activeFilters: Record<string, string> = {}): HourlyPriceDisplayResult => {
    const { abTests = {} } = getContext();
    const hourlyToggleExperimentGroup = Number(abTests?.[EXPERIMENTS.COBRAS_HOURLY_FILTER_EXPOSURE] ?? 0);
    const isHourlyFilterActive = activeFilters?.has_hourly?.toString()?.toLowerCase() === 'true';
    const isInHourlyExperiment = hourlyToggleExperimentGroup > 1;
    const showHourlyPrice = isInHourlyExperiment && isHourlyFilterActive;
    const shouldRouteToSeller = hourlyToggleExperimentGroup === Number(ALLOCATIONS.TEST_C) && isHourlyFilterActive;

    return { showHourlyPrice, shouldRouteToSeller };
};
